var cov_wkn75q0x6 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Tabs/Tab.tsx",
      hash = "fa56f92475f143eddb3f43eb701ee9a13895a352",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Tabs/Tab.tsx",
    statementMap: {
      "0": {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 16,
          column: 16
        }
      },
      "1": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 17,
          column: 56
        }
      },
      "2": {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 18,
          column: 50
        }
      },
      "3": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 19,
          column: 42
        }
      },
      "4": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 25,
          column: 6
        }
      },
      "5": {
        start: {
          line: 24,
          column: 6
        },
        end: {
          line: 24,
          column: 53
        }
      },
      "6": {
        start: {
          line: 24,
          column: 31
        },
        end: {
          line: 24,
          column: 53
        }
      },
      "7": {
        start: {
          line: 29,
          column: 78
        },
        end: {
          line: 29,
          column: 88
        }
      },
      "8": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 31,
          column: 55
        }
      },
      "9": {
        start: {
          line: 31,
          column: 46
        },
        end: {
          line: 31,
          column: 55
        }
      },
      "10": {
        start: {
          line: 33,
          column: 33
        },
        end: {
          line: 33,
          column: 54
        }
      },
      "11": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 35,
          column: 51
        }
      },
      "12": {
        start: {
          line: 35,
          column: 30
        },
        end: {
          line: 35,
          column: 51
        }
      },
      "13": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 38,
          column: 91
        }
      },
      "14": {
        start: {
          line: 38,
          column: 6
        },
        end: {
          line: 38,
          column: 91
        }
      },
      "15": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 41,
          column: 92
        }
      },
      "16": {
        start: {
          line: 41,
          column: 6
        },
        end: {
          line: 41,
          column: 92
        }
      },
      "17": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 44,
          column: 91
        }
      },
      "18": {
        start: {
          line: 44,
          column: 6
        },
        end: {
          line: 44,
          column: 91
        }
      },
      "19": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 16
        }
      },
      "20": {
        start: {
          line: 50,
          column: 54
        },
        end: {
          line: 50,
          column: 64
        }
      },
      "21": {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 51,
          column: 24
        }
      },
      "22": {
        start: {
          line: 51,
          column: 18
        },
        end: {
          line: 51,
          column: 24
        }
      },
      "23": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 53,
          column: 44
        }
      },
      "24": {
        start: {
          line: 53,
          column: 23
        },
        end: {
          line: 53,
          column: 44
        }
      },
      "25": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 56,
          column: 5
        }
      },
      "26": {
        start: {
          line: 55,
          column: 6
        },
        end: {
          line: 55,
          column: 60
        }
      },
      "27": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 59,
          column: 5
        }
      },
      "28": {
        start: {
          line: 58,
          column: 6
        },
        end: {
          line: 58,
          column: 83
        }
      },
      "29": {
        start: {
          line: 63,
          column: 67
        },
        end: {
          line: 63,
          column: 77
        }
      },
      "30": {
        start: {
          line: 65,
          column: 18
        },
        end: {
          line: 65,
          column: 39
        }
      },
      "31": {
        start: {
          line: 66,
          column: 23
        },
        end: {
          line: 66,
          column: 43
        }
      },
      "32": {
        start: {
          line: 68,
          column: 18
        },
        end: {
          line: 81,
          column: 5
        }
      },
      "33": {
        start: {
          line: 83,
          column: 4
        },
        end: {
          line: 85,
          column: 5
        }
      },
      "34": {
        start: {
          line: 84,
          column: 6
        },
        end: {
          line: 84,
          column: 55
        }
      },
      "35": {
        start: {
          line: 87,
          column: 4
        },
        end: {
          line: 87,
          column: 43
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 15,
            column: 3
          }
        },
        loc: {
          start: {
            line: 15,
            column: 31
          },
          end: {
            line: 20,
            column: 3
          }
        },
        line: 15
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 22,
            column: 3
          }
        },
        loc: {
          start: {
            line: 22,
            column: 22
          },
          end: {
            line: 26,
            column: 3
          }
        },
        line: 22
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 23,
            column: 10
          },
          end: {
            line: 23,
            column: 11
          }
        },
        loc: {
          start: {
            line: 23,
            column: 16
          },
          end: {
            line: 25,
            column: 5
          }
        },
        line: 23
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        },
        loc: {
          start: {
            line: 28,
            column: 19
          },
          end: {
            line: 47,
            column: 3
          }
        },
        line: 28
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 49,
            column: 2
          },
          end: {
            line: 49,
            column: 3
          }
        },
        loc: {
          start: {
            line: 49,
            column: 25
          },
          end: {
            line: 60,
            column: 3
          }
        },
        line: 49
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 62,
            column: 2
          },
          end: {
            line: 62,
            column: 3
          }
        },
        loc: {
          start: {
            line: 62,
            column: 11
          },
          end: {
            line: 88,
            column: 3
          }
        },
        line: 62
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 24,
            column: 6
          },
          end: {
            line: 24,
            column: 53
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 24,
            column: 6
          },
          end: {
            line: 24,
            column: 53
          }
        }, {
          start: {
            line: 24,
            column: 6
          },
          end: {
            line: 24,
            column: 53
          }
        }],
        line: 24
      },
      "1": {
        loc: {
          start: {
            line: 31,
            column: 4
          },
          end: {
            line: 31,
            column: 55
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 31,
            column: 4
          },
          end: {
            line: 31,
            column: 55
          }
        }, {
          start: {
            line: 31,
            column: 4
          },
          end: {
            line: 31,
            column: 55
          }
        }],
        line: 31
      },
      "2": {
        loc: {
          start: {
            line: 31,
            column: 8
          },
          end: {
            line: 31,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 31,
            column: 8
          },
          end: {
            line: 31,
            column: 24
          }
        }, {
          start: {
            line: 31,
            column: 28
          },
          end: {
            line: 31,
            column: 44
          }
        }],
        line: 31
      },
      "3": {
        loc: {
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 35,
            column: 51
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 35,
            column: 51
          }
        }, {
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 35,
            column: 51
          }
        }],
        line: 35
      },
      "4": {
        loc: {
          start: {
            line: 37,
            column: 4
          },
          end: {
            line: 38,
            column: 91
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 37,
            column: 4
          },
          end: {
            line: 38,
            column: 91
          }
        }, {
          start: {
            line: 37,
            column: 4
          },
          end: {
            line: 38,
            column: 91
          }
        }],
        line: 37
      },
      "5": {
        loc: {
          start: {
            line: 37,
            column: 8
          },
          end: {
            line: 37,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 37,
            column: 8
          },
          end: {
            line: 37,
            column: 24
          }
        }, {
          start: {
            line: 37,
            column: 28
          },
          end: {
            line: 37,
            column: 39
          }
        }],
        line: 37
      },
      "6": {
        loc: {
          start: {
            line: 38,
            column: 49
          },
          end: {
            line: 38,
            column: 79
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 38,
            column: 60
          },
          end: {
            line: 38,
            column: 70
          }
        }, {
          start: {
            line: 38,
            column: 73
          },
          end: {
            line: 38,
            column: 79
          }
        }],
        line: 38
      },
      "7": {
        loc: {
          start: {
            line: 40,
            column: 4
          },
          end: {
            line: 41,
            column: 92
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 40,
            column: 4
          },
          end: {
            line: 41,
            column: 92
          }
        }, {
          start: {
            line: 40,
            column: 4
          },
          end: {
            line: 41,
            column: 92
          }
        }],
        line: 40
      },
      "8": {
        loc: {
          start: {
            line: 40,
            column: 8
          },
          end: {
            line: 40,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 40,
            column: 8
          },
          end: {
            line: 40,
            column: 24
          }
        }, {
          start: {
            line: 40,
            column: 28
          },
          end: {
            line: 40,
            column: 53
          }
        }],
        line: 40
      },
      "9": {
        loc: {
          start: {
            line: 41,
            column: 39
          },
          end: {
            line: 41,
            column: 69
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 41,
            column: 50
          },
          end: {
            line: 41,
            column: 60
          }
        }, {
          start: {
            line: 41,
            column: 63
          },
          end: {
            line: 41,
            column: 69
          }
        }],
        line: 41
      },
      "10": {
        loc: {
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 44,
            column: 91
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 44,
            column: 91
          }
        }, {
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 44,
            column: 91
          }
        }],
        line: 43
      },
      "11": {
        loc: {
          start: {
            line: 43,
            column: 8
          },
          end: {
            line: 43,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 43,
            column: 8
          },
          end: {
            line: 43,
            column: 24
          }
        }, {
          start: {
            line: 43,
            column: 28
          },
          end: {
            line: 43,
            column: 54
          }
        }],
        line: 43
      },
      "12": {
        loc: {
          start: {
            line: 44,
            column: 59
          },
          end: {
            line: 44,
            column: 89
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 44,
            column: 70
          },
          end: {
            line: 44,
            column: 80
          }
        }, {
          start: {
            line: 44,
            column: 83
          },
          end: {
            line: 44,
            column: 89
          }
        }],
        line: 44
      },
      "13": {
        loc: {
          start: {
            line: 51,
            column: 4
          },
          end: {
            line: 51,
            column: 24
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 51,
            column: 4
          },
          end: {
            line: 51,
            column: 24
          }
        }, {
          start: {
            line: 51,
            column: 4
          },
          end: {
            line: 51,
            column: 24
          }
        }],
        line: 51
      },
      "14": {
        loc: {
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 53,
            column: 44
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 53,
            column: 44
          }
        }, {
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 53,
            column: 44
          }
        }],
        line: 53
      },
      "15": {
        loc: {
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 56,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 56,
            column: 5
          }
        }, {
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 56,
            column: 5
          }
        }],
        line: 54
      },
      "16": {
        loc: {
          start: {
            line: 57,
            column: 4
          },
          end: {
            line: 59,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 57,
            column: 4
          },
          end: {
            line: 59,
            column: 5
          }
        }, {
          start: {
            line: 57,
            column: 4
          },
          end: {
            line: 59,
            column: 5
          }
        }],
        line: 57
      },
      "17": {
        loc: {
          start: {
            line: 57,
            column: 8
          },
          end: {
            line: 57,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 57,
            column: 8
          },
          end: {
            line: 57,
            column: 20
          }
        }, {
          start: {
            line: 57,
            column: 24
          },
          end: {
            line: 57,
            column: 58
          }
        }],
        line: 57
      },
      "18": {
        loc: {
          start: {
            line: 72,
            column: 10
          },
          end: {
            line: 72,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 72,
            column: 10
          },
          end: {
            line: 72,
            column: 18
          }
        }, {
          start: {
            line: 72,
            column: 23
          },
          end: {
            line: 72,
            column: 68
          }
        }],
        line: 72
      },
      "19": {
        loc: {
          start: {
            line: 72,
            column: 23
          },
          end: {
            line: 72,
            column: 68
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 72,
            column: 36
          },
          end: {
            line: 72,
            column: 57
          }
        }, {
          start: {
            line: 72,
            column: 60
          },
          end: {
            line: 72,
            column: 68
          }
        }],
        line: 72
      },
      "20": {
        loc: {
          start: {
            line: 73,
            column: 10
          },
          end: {
            line: 73,
            column: 32
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 73,
            column: 10
          },
          end: {
            line: 73,
            column: 18
          }
        }, {
          start: {
            line: 73,
            column: 22
          },
          end: {
            line: 73,
            column: 32
          }
        }],
        line: 73
      },
      "21": {
        loc: {
          start: {
            line: 74,
            column: 10
          },
          end: {
            line: 74,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 74,
            column: 10
          },
          end: {
            line: 74,
            column: 20
          }
        }, {
          start: {
            line: 74,
            column: 24
          },
          end: {
            line: 74,
            column: 57
          }
        }],
        line: 74
      },
      "22": {
        loc: {
          start: {
            line: 83,
            column: 4
          },
          end: {
            line: 85,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 83,
            column: 4
          },
          end: {
            line: 85,
            column: 5
          }
        }, {
          start: {
            line: 83,
            column: 4
          },
          end: {
            line: 85,
            column: 5
          }
        }],
        line: 83
      },
      "23": {
        loc: {
          start: {
            line: 83,
            column: 8
          },
          end: {
            line: 83,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 83,
            column: 8
          },
          end: {
            line: 83,
            column: 21
          }
        }, {
          start: {
            line: 83,
            column: 25
          },
          end: {
            line: 83,
            column: 48
          }
        }],
        line: 83
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Tabs/Tab.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { tabsClass } from './styles';
import { getUidStr } from '../utils/uid';
import { defer } from '../utils/uid';
import getDataset from '../utils/dom/getDataset';
import { getDirectionClass } from '../utils/classname';

var Tab =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Tab, _PureComponent);

  var _super = _createSuper2(Tab);

  function Tab(props) {
    var _this;

    _classCallCheck(this, Tab);

    cov_wkn75q0x6.f[0]++;
    cov_wkn75q0x6.s[0]++;
    _this = _super.call(this, props);
    _this.element = void 0;
    _this.uid = void 0;
    cov_wkn75q0x6.s[1]++;
    _this.getActiveStyle = _this.getActiveStyle.bind(_assertThisInitialized(_this));
    cov_wkn75q0x6.s[2]++;
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    cov_wkn75q0x6.s[3]++;
    _this.uid = "tab_unique_".concat(getUidStr());
    return _this;
  }

  _createClass(Tab, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      cov_wkn75q0x6.f[1]++;
      cov_wkn75q0x6.s[4]++;
      defer(function () {
        cov_wkn75q0x6.f[2]++;
        cov_wkn75q0x6.s[5]++;

        if (_this2.props.isActive) {
          cov_wkn75q0x6.b[0][0]++;
          cov_wkn75q0x6.s[6]++;

          _this2.handleClick(true);
        } else {
          cov_wkn75q0x6.b[0][1]++;
        }
      });
    }
  }, {
    key: "getActiveStyle",
    value: function getActiveStyle() {
      cov_wkn75q0x6.f[3]++;

      var _ref = (cov_wkn75q0x6.s[7]++, this.props),
          shape = _ref.shape,
          align = _ref.align,
          background = _ref.background,
          color = _ref.color,
          border = _ref.border,
          isActive = _ref.isActive,
          isVertical = _ref.isVertical;

      cov_wkn75q0x6.s[8]++;

      if ((cov_wkn75q0x6.b[2][0]++, shape === 'line') || (cov_wkn75q0x6.b[2][1]++, shape === 'dash')) {
        cov_wkn75q0x6.b[1][0]++;
        cov_wkn75q0x6.s[9]++;
        return {};
      } else {
        cov_wkn75q0x6.b[1][1]++;
      }

      var style = (cov_wkn75q0x6.s[10]++, {
        background: background,
        color: color
      });
      cov_wkn75q0x6.s[11]++;

      if (shape === 'bordered') {
        cov_wkn75q0x6.b[3][0]++;
        cov_wkn75q0x6.s[12]++;
        return {
          background: background
        };
      } else {
        cov_wkn75q0x6.b[3][1]++;
      }

      cov_wkn75q0x6.s[13]++;

      if ((cov_wkn75q0x6.b[5][0]++, shape !== 'line') && (cov_wkn75q0x6.b[5][1]++, !isVertical)) {
        cov_wkn75q0x6.b[4][0]++;
        cov_wkn75q0x6.s[14]++;
        style.borderColor = "".concat(border, " ").concat(border, " ").concat(isActive ? (cov_wkn75q0x6.b[6][0]++, background) : (cov_wkn75q0x6.b[6][1]++, border), " ").concat(border);
      } else {
        cov_wkn75q0x6.b[4][1]++;
      }

      cov_wkn75q0x6.s[15]++;

      if ((cov_wkn75q0x6.b[8][0]++, shape !== 'line') && (cov_wkn75q0x6.b[8][1]++, align === 'vertical-left')) {
        cov_wkn75q0x6.b[7][0]++;
        cov_wkn75q0x6.s[16]++;
        style.borderColor = "".concat(border, " ").concat(isActive ? (cov_wkn75q0x6.b[9][0]++, background) : (cov_wkn75q0x6.b[9][1]++, border), "  ").concat(border, " ").concat(border);
      } else {
        cov_wkn75q0x6.b[7][1]++;
      }

      cov_wkn75q0x6.s[17]++;

      if ((cov_wkn75q0x6.b[11][0]++, shape !== 'line') && (cov_wkn75q0x6.b[11][1]++, align === 'vertical-right')) {
        cov_wkn75q0x6.b[10][0]++;
        cov_wkn75q0x6.s[18]++;
        style.borderColor = "".concat(border, " ").concat(border, " ").concat(border, " ").concat(isActive ? (cov_wkn75q0x6.b[12][0]++, background) : (cov_wkn75q0x6.b[12][1]++, border));
      } else {
        cov_wkn75q0x6.b[10][1]++;
      }

      cov_wkn75q0x6.s[19]++;
      return style;
    }
  }, {
    key: "handleClick",
    value: function handleClick(init) {
      cov_wkn75q0x6.f[4]++;

      var _ref2 = (cov_wkn75q0x6.s[20]++, this.props),
          onClick = _ref2.onClick,
          id = _ref2.id,
          isActive = _ref2.isActive,
          disabled = _ref2.disabled,
          last = _ref2.last;

      cov_wkn75q0x6.s[21]++;

      if (disabled) {
        cov_wkn75q0x6.b[13][0]++;
        cov_wkn75q0x6.s[22]++;
        return;
      } else {
        cov_wkn75q0x6.b[13][1]++;
      }

      cov_wkn75q0x6.s[23]++;

      if (init !== true) {
        cov_wkn75q0x6.b[14][0]++;
        cov_wkn75q0x6.s[24]++;
        onClick(id, isActive);
      } else {
        cov_wkn75q0x6.b[14][1]++;
      }

      cov_wkn75q0x6.s[25]++;

      if (!this.element) {
        cov_wkn75q0x6.b[15][0]++;
        cov_wkn75q0x6.s[26]++;
        this.element = document.querySelector(".".concat(this.uid));
      } else {
        cov_wkn75q0x6.b[15][1]++;
      }

      cov_wkn75q0x6.s[27]++;

      if ((cov_wkn75q0x6.b[17][0]++, this.element) && (cov_wkn75q0x6.b[17][1]++, this.element.getBoundingClientRect)) {
        cov_wkn75q0x6.b[16][0]++;
        cov_wkn75q0x6.s[28]++;
        this.props.moveToCenter(this.element.getBoundingClientRect(), last, id === 0);
      } else {
        cov_wkn75q0x6.b[16][1]++;
      }
    }
  }, {
    key: "render",
    value: function render() {
      cov_wkn75q0x6.f[5]++;

      var _ref3 = (cov_wkn75q0x6.s[29]++, this.props),
          isActive = _ref3.isActive,
          disabled = _ref3.disabled,
          children = _ref3.children,
          shape = _ref3.shape,
          otherProps = _objectWithoutProperties(_ref3, ["isActive", "disabled", "children", "shape"]);

      var style = (cov_wkn75q0x6.s[30]++, this.getActiveStyle());
      var isBordered = (cov_wkn75q0x6.s[31]++, shape === 'bordered');
      var props = (cov_wkn75q0x6.s[32]++, _objectSpread2({
        className: classnames(tabsClass('tab', (cov_wkn75q0x6.b[18][0]++, isActive) && (cov_wkn75q0x6.b[18][1]++, isBordered ? (cov_wkn75q0x6.b[19][0]++, 'tab-bordered-active') : (cov_wkn75q0x6.b[19][1]++, 'active')), (cov_wkn75q0x6.b[20][0]++, disabled) && (cov_wkn75q0x6.b[20][1]++, 'disabled'), (cov_wkn75q0x6.b[21][0]++, isBordered) && (cov_wkn75q0x6.b[21][1]++, getDirectionClass('tab-bordered'))), this.uid),
        onClick: this.handleClick,
        style: style
      }, getDataset(otherProps)));
      cov_wkn75q0x6.s[33]++;

      if ((cov_wkn75q0x6.b[23][0]++, children.type) && (cov_wkn75q0x6.b[23][1]++, children.type.isTabLink)) {
        cov_wkn75q0x6.b[22][0]++;
        cov_wkn75q0x6.s[34]++;
        return (
          /*#__PURE__*/
          React.cloneElement(children, _objectSpread2({}, props))
        );
      } else {
        cov_wkn75q0x6.b[22][1]++;
      }

      cov_wkn75q0x6.s[35]++;
      return (
        /*#__PURE__*/
        React.createElement("div", Object.assign({}, props, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 87,
            columnNumber: 12
          }
        }), children)
      );
    }
  }]);

  return Tab;
}(PureComponent);

export default Tab;